<template>
<div >
   
  <b-modal v-if="!modaladd" id="modal-ajoutprod" hide-footer centered title="Ajouter Categorie ">
    
 
  <form @submit="formSubmit">
    
    <div class="pl-lg-4">
      <div class="row">
       <div class="col-lg-12">
           <b-form-group
        id="input-group-1"
        label="Titre"
        label-for="input-1"
       >
          <b-form-input
             
            label="Titre"
            placeholder="titre categorie"
            input-classes="form-control-alternative"
            v-model="model.libelle"
            
            required
          />
           </b-form-group>
        </div>
        
         
        <div class="col-lg-6">
           
        </div>
       
      </div>
       
    </div>
    
   
    <hr class="my-4" />
    <!-- Description -->
   <center><b-btn type="submit" style="background-color:#c2b59b;color:#fff" >Ajouter</b-btn></center> 
  </form>
   </b-modal>
</div>
</template>
<script>
import { setToken, post } from "@/mixins/api";
export default {
     name: 'ModalAddCategorie',
    data() {
      return {
        
      modaladd:false,
      
        model: {
      

          libelle: '',
          
          
          
        },
         userToken:
        localStorage.getItem("userToken") ||
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEsImlhdCI6MTU3OTczNDkxMSwiZXhwIjoxNjExMjcwOTExfQ.96_I_ZUs7ALBMY4pDsnjbT-fvvagVMsVlpi48eAKWGk"
      
      }
    },
    methods:{
       formSubmit() {
               //e.preventDefault();
                  //let currentObj = this;
                post("category",this.model)
                 .then(resp => {
        
        this.data = resp.data.data;
       this.$emit("categorieadd",this.data,this.modaladd=false);
        
        
         
      });
                
           this.modaladd = true;    
      
               // e.target.reset(); 
            }, 
  },
     mounted() {
    setToken(this.userToken);
    //this.loadData();
    
  },
}
</script>
                        
  
<style lang="scss" scoped>
img {
      float:left;
    border-style: none;
    width: 100px;
    height: 80px;
     
}
</style>